import { GiftCard } from '@kinomap-dev/ng-ui-lib';
import { createActionGroup, props } from '@ngrx/store';
import { SubscriptionPlan } from 'app/models/subscrition-plan.model';
import { CurrencyType } from 'app/services/gift-cards-plans.service';

export const SubscriptionsProductsActions = createActionGroup({
  source: 'subscritions',
  events: {
    'Set Subscriptions Products': props<{
      subscriptionsProducts: SubscriptionPlan[];
    }>(),
    'Get Subscriptions Products': props<{ currency: CurrencyType }>(),
  },
});

export const GiftCardsProductsActions = createActionGroup({
  source: 'giftCards',
  events: {
    'Set GiftCards Products': props<{ giftCardsProducts: GiftCard[] }>(),
    'Get GiftCards Products': props<{ currency: CurrencyType }>(),
  },
});
